var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6673 8.1908L16.7127 0.315801C16.4983 0.110873 16.2113 -0.00252069 15.9133 4.25278e-05C15.6154 0.00260575 15.3304 0.120921 15.1197 0.329505C14.909 0.538089 14.7895 0.820253 14.7869 1.11522C14.7843 1.4102 14.8988 1.69437 15.1058 1.90655L21.1207 7.86118H1.13637C0.834989 7.86118 0.545948 7.9797 0.332836 8.19068C0.119725 8.40166 0 8.68781 0 8.98618C0 9.28454 0.119725 9.57069 0.332836 9.78167C0.545948 9.99265 0.834989 10.1112 1.13637 10.1112H21.1207L15.1058 16.0658C14.9973 16.1696 14.9107 16.2937 14.8512 16.431C14.7916 16.5682 14.7603 16.7158 14.7589 16.8652C14.7576 17.0146 14.7864 17.1627 14.8435 17.301C14.9007 17.4393 14.985 17.5649 15.0917 17.6705C15.1984 17.7761 15.3253 17.8597 15.465 17.9162C15.6046 17.9728 15.7543 18.0013 15.9052 18C16.056 17.9987 16.2052 17.9676 16.3438 17.9087C16.4824 17.8497 16.6078 17.764 16.7127 17.6566L24.6673 9.78155C24.8803 9.57058 25 9.28449 25 8.98618C25 8.68787 24.8803 8.40177 24.6673 8.1908Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.8f692a447a55c48ab68129796ffc03d7.svg";
export { ForwardRef as ReactComponent };